<div class="app-datepicker-wrapper" [ngClass]="customClass">
  <!-- Header Label -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
    [optional]="optional"
    [tooltip]="tooltip"
    [icon]="labelIcon"
    [size]="labelSize"
    [forId]="id"
  ></app-label>

  <!-- Input Trigger Container -->
  <div
    class="app-datepicker-container"
    [ngClass]="[
      'app-datepicker--' + (size || 'md'),
      isFocused || isPickerOpen ? 'app-datepicker--focused app-datepicker--open' : '',
      hasError ? 'app-datepicker--error' : '',
      disabled ? 'app-datepicker--disabled' : '',
      readonly ? 'app-datepicker--readonly' : '',
      containerClass
    ]"
    [style.height]="resolvedHeight ? resolvedHeight : null"
    [style.minHeight]="resolvedHeight ? resolvedHeight : null"
    (click)="openPicker($event)"
  >
    <!-- Actual Mat Datepicker input (hidden visually but functional for accessibility / form control) -->
    <input
      #dateInput
      [matDatepicker]="picker"
      [value]="value"
      [min]="minDateParsed"
      [max]="maxDateParsed"
      [disabled]="disabled"
      (dateChange)="onDateSelect($event)"
      (dateInput)="onDateSelect($event)"
      class="app-datepicker-hidden-input"
      tabindex="-1"
      readonly
    />

    <!-- Visible Text Display -->
    <div class="app-datepicker-display">
      <span *ngIf="displayValue" class="app-datepicker-value">{{ displayValue }}</span>
      <span *ngIf="!displayValue" class="app-datepicker-placeholder">{{ placeholder }}</span>
    </div>

    <!-- Actions: Clear Button & Calendar Icon -->
    <div class="app-datepicker-actions">
      <!-- Clear button -->
      <button
        type="button"
        *ngIf="clearable && value && !disabled && !readonly"
        class="app-datepicker-clear-btn"
        (click)="handleClear($event)"
        tabindex="-1"
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
          <path
            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm2.47-9.53a.75.75 0 0 0-1.06-1.06L8 5.82 6.59 4.41a.75.75 0 0 0-1.06 1.06L6.94 6.88 5.53 8.29a.75.75 0 1 0 1.06 1.06L8 7.94l1.41 1.41a.75.75 0 0 0 1.06-1.06L9.06 6.88l1.41-1.41z"
          />
        </svg>
      </button>

      <!-- Calendar SVG Toggle Icon matching Expense -->
      <span class="app-datepicker-icon-btn" [class.app-datepicker-icon-btn--disabled]="disabled">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="app-datepicker-calendar-icon"
        >
          <path
            d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 2V6"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 2V6"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3 10H21"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect x="7" y="14" width="2" height="2" rx="0.5" fill="currentColor" />
          <rect x="11" y="14" width="2" height="2" rx="0.5" fill="currentColor" />
          <rect x="15" y="14" width="2" height="2" rx="0.5" fill="currentColor" />
          <rect x="7" y="18" width="2" height="2" rx="0.5" fill="currentColor" />
          <rect x="11" y="18" width="2" height="2" rx="0.5" fill="currentColor" />
          <rect x="15" y="18" width="2" height="2" rx="0.5" fill="currentColor" />
        </svg>
      </span>
    </div>

    <!-- Angular Material Datepicker -->
    <mat-datepicker
      #picker
      (opened)="onPickerOpened()"
      (closed)="onPickerClosed()"
      panelClass="app-datepicker-panel"
    ></mat-datepicker>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError" class="app-datepicker-error">
    {{ activeError }}
  </div>

  <!-- Helper Text -->
  <div *ngIf="helperText && !hasError" class="app-datepicker-helper">
    {{ helperText }}
  </div>
</div>
